import format from 'date-fns/format'
import React, { useContext, useEffect, useState } from 'react'

import { Button } from '../../../../components/common/Button'
import { Select } from '../../../../components/common/Select'
import { ContextLatestRequests } from '../../../../context/context_latestRequests'
import {
  Container,
  SelectContainer,
  StatusBox,
  Table,
  TableCell,
  TableCellEmpty,
  TableHeader,
} from './styles'

import { Eye } from '@phosphor-icons/react'
import { Title } from '../../styles'
import api from '../../../../services/api'

export const TableRequests = ({ data, getOccurrence, openDetails }) => {
  const {
    handleFilters,
    // callFilteredOccurrences
    filter,
    setOccurrencesList,
  } = useContext(ContextLatestRequests)

  const callFilteredOccurrences = (filters) => {
    if (filters?.status === '') delete filters.status
    if (filters?.customer === '') delete filters.customer
    if (filters?.start_date === '') delete filters.start_date
    if (filters?.end_date === '') delete filters.end_date
    if (filters?.start_hour === '') delete filters.start_hour
    api
      .post('/v1/dashboard/surveillance/occurrences', filters)
      .then((response) => {
        if (response && response.data) {
          // console.log(response.data)
          // console.log(filters)
          setOccurrencesList(response.data)
        }
      })
      .catch((error) => {
        console.log(error.response.data.statusCode)
      })
  }

  const [status, setStatus] = useState('')

  useEffect(() => {
    callFilteredOccurrences(filter)
  }, [status])

  return (
    <Container>
      <SelectContainer>
        <Title>Reordenar visualização</Title>
        <Select
          bordercolor="#CECECE"
          backgroundcolor="#f7f7f7"
          currentOption={status}
          label={{ title: '', htmlFor: '' }}
          onchange={(e) => {
            handleFilters('status', e.target.value)
            setStatus(e.target.value)
          }}
          data={[
            { id: 'ABERTO', value: 'Aguardando ação' },
            { id: 'EMPROGRESSO', value: 'Em ocorrência' },
          ]}
        />
      </SelectContainer>
      <Table>
        <thead>
          <tr>
            <TableHeader>Nome</TableHeader>
            <TableHeader>ID ocorrência</TableHeader>
            <TableHeader>Posto</TableHeader>
            <TableHeader>Modalidade</TableHeader>
            <TableHeader>Horário de envio</TableHeader>
            <TableHeader>Status atual</TableHeader>
            <TableHeader>Segurança responsável</TableHeader>
            <TableHeader>Ver detalhes</TableHeader>
          </tr>
        </thead>
        <tbody>
          {data === undefined || data === null || data.length === 0 ? (
            <tr>
              <TableCellEmpty colSpan={8}>
                Nenhum dado encontrado
              </TableCellEmpty>
            </tr>
          ) : (
            data.map((val) => {
              return (
                <tr key={val.Occurrence.id}>
                  <TableCell>{val.Resident.name}</TableCell>
                  <TableCell>{val.Occurrence.code}</TableCell>
                  <TableCell>
                    {val.Occurrence.Base ? val.Occurrence.Base.outpost : ''}
                  </TableCell>
                  <TableCell>{val.Occurrence.type}</TableCell>
                  <TableCell>
                    {format(
                      new Date(val.Occurrence.created_at),
                      'dd/MM/yyyy HH:mm:ss',
                    )}
                  </TableCell>
                  <TableCell>
                    {val.Occurrence.status === 'Em ocorrência' ? (
                      <StatusBox status={val.Occurrence.status}>
                        Em ocorrência - #{val.Occurrence.code}
                      </StatusBox>
                    ) : (
                      <StatusBox status={val.Occurrence.status}>
                        Aguardando ação
                      </StatusBox>
                    )}
                  </TableCell>
                  <TableCell>
                    {val.Employee.length === 0 ? '-' : val.Employee.name}
                  </TableCell>
                  <TableCell>
                    <Button.Root
                      onClick={() => {
                        getOccurrence(val)
                        openDetails()
                      }}
                      backgroundColor="#00517D"
                      type="button"
                      padding="0 0 0 0.2rem"
                    >
                      <Button.Content title="Ver detalhe" color="#fff" />
                      <Button.Icon>
                        <Eye size={24} color="#fff" />
                      </Button.Icon>
                    </Button.Root>
                  </TableCell>
                </tr>
              )
            })
          )}
        </tbody>
      </Table>
    </Container>
  )
}
